import { SyntheticEvent } from "react";

export function formCheckError(
  event: SyntheticEvent | KeyboardEvent,
  fieldname: string,
  field: string | undefined,
  fieldRef: any,
  t: any
) {
  if (fieldname === "password" && field && field?.length < 8) {
    fieldRef?.current.setCustomValidity(t("at_least_password"));
    fieldRef.current?.reportValidity();
  } else if (fieldname === "country" && !field) {
    event.preventDefault();
    fieldRef?.setCustomValidity(t("valid_country"));
    fieldRef?.reportValidity();
  } else if (!field) {
    event.preventDefault();
    fieldRef?.current.setCustomValidity(t("valid_field"));
    fieldRef.current?.reportValidity();
  }
}
